import { Link } from "react-router-dom";
import TableActionMenu from "../../../../../components/table-action-menu/table-action-menu";


export const linkedContactsColumns = (handleRemoveContact, navigate) => {
  return [
    {
      name: "Name",
      dataKey: "firstName",
      width: "400px",
      minWidth: "400px",
      align: "left",
      render: (cellData, rowData) => {
        const contactUrl = `/contactsview/${rowData.id}/details`
        const fullName = `${rowData.firstName} ${rowData.lastName}`;
        return (
          <Link
            to={contactUrl}
            style={{
              textDecoration: "underline",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            {fullName}
          </Link>
        );
      },
    },

    {
      name: "Title",
      dataKey: "title",
      width: "200px",
      minWidth: "200px",
      align: "left",
    },
    {
      name: "Email",
      dataKey: "emailAddress",
      width: "300px",
      minWidth: "300px",
      align: "left",
    },
    {
        name: "Phone",
        dataKey: "phoneNumber",
        width: "175px",
        align: "left",
    },
    {
        name: "Type",
        dataKey: "type",
        width: "175px",
        align: "left",
      },
      {
        name: "State",
        dataKey: "contactState",
        width: "175px",
        align: "left",
      },
      {
        name: "",
        dataKey: "actions",
        width: "10px",
        align: "center",
        render: (cellData, rowData) => (
          <TableActionMenu
            options={[
              {
                title: "View Contact Page",
                onClick: () => {
                  navigate(`/contactsview/${rowData.id}/details`);
                },
              },
              // {
              //   title: "Remove Contact",
              //   onClick: () => handleRemoveContact(rowData),
              // },
            ]}
          />
        ),
      },
  ];
};
